if (!customElements.get('product-hotspots')) {
  class Hotspots extends window.BAO.CustomElement() {
    constructor () {
      super()

      this.classes = {
        active: 'prd-Hotspot-active',
      }
    }

    connectedCallback () {
      super.connectedCallback()
    }

    setupListeners () {
      super.setupListeners()

      this.els?.form?.elements.forEach((form) => {
        form.addEventListener('submit', () => {
          this.hideAllPopups()
        })
      })

      this.querySelectorAll('product-quick-add-trigger button').forEach((btn) => {
        btn.addEventListener('click', () => {
          const trigger = btn.closest('product-quick-add-trigger')

          if (trigger) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'hotspots_add_to_cart',
              product_id: trigger.dataset.productId,
              variant_id: trigger.dataset.variantId,
              price: trigger.dataset.price,
            })
          }

          this.hideAllPopups()
        })
      })

      this.els?.toggle?.elements.forEach((toggle) => {
        const parentHotspot = toggle.closest(
          '[data-product-hotspots-el="hotspot"]',
        )

        if (!parentHotspot) return

        toggle.addEventListener('click', () => {
          this.hideOtherPopups(parentHotspot)
          parentHotspot.classList.toggle(this.classes.active)

          if (parentHotspot.classList.contains(this.classes.active)) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'hotspots_clicked',
              handle: parentHotspot.dataset.productHandle,
            })
          }
        })
      })

      this.els?.close?.elements.forEach((close) => {
        const parentHotspot = close.closest(
          '[data-product-hotspots-el="hotspot"]',
        )

        if (!parentHotspot) return

        close.addEventListener('click', () => {
          parentHotspot.classList.remove(this.classes.active)
        })
      })
    }

    hideAllPopups () {
      this.els?.hotspot?.elements.forEach((hotspot) => {
        hotspot.classList.remove(this.classes.active)
      })
    }

    hideOtherPopups (target) {
      this.els?.hotspot?.elements.forEach((hotspot) => {
        if (hotspot !== target) hotspot.classList.remove(this.classes.active)
      })
    }
  }

  customElements.define('product-hotspots', Hotspots)
}
